import React, {useState} from 'react';

import {Button, InputNumber} from '@kit';

import {useCharacter} from '../character-context';
import type {HitPointsState} from '../model/character-state';
import {withJournalEntry} from '../model/journal';

import {cls} from '../../../../components/utils';

import css from './sheet.module.css';

type Props = {
	/** кнопки и поле друг под другом */
	vertical?: boolean;
};

/** исцеление и урон на введённое число; Enter наносит урон */
export const HealDamageForm: React.FC<Props> = ({vertical}) => {
	const {character, update} = useCharacter();
	const [amount, setAmount] = useState<number | null>(null);

	const applyAmount = (title: string, change: (value: number) => HitPointsState) => {
		if (!amount || amount <= 0) return;
		update((current) => ({
			hitPoints: change(amount),
			...withJournalEntry(current, {kind: 'hitPoints', title, total: amount}),
		}));
		setAmount(null);
	};

	return (
		<form
			className={cls(css.hitPointsControls, vertical && css.hitPointsControlsVertical)}
			onSubmit={(event) => {
				event.preventDefault();
				applyAmount('Урон', (value) => character.takeDamage(value));
			}}
		>
			<Button appearance="success" onClick={() => applyAmount('Исцеление', (value) => character.heal(value))}>
				Исцеление
			</Button>
			<InputNumber min={0} placeholder="0" value={amount} onChange={setAmount} disableClear />
			<Button type="submit" appearance="destructive">
				Урон
			</Button>
		</form>
	);
};
